import React from 'react';

interface Testimonial {
  name: string;
  location: string;
  rating: number;
  text: string;
  service?: string;
  avatar?: string;
}

interface TestimonialGridProps {
  title?: string;
  subtitle?: string;
  testimonials: Testimonial[];
}

export const TestimonialGrid: React.FC<TestimonialGridProps> = ({
  title = "Customer Testimonials",
  subtitle = "Real feedback from our satisfied customers",
  testimonials
}) => {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i key={index} className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400`}></i>
    ));
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {testimonial.avatar && (
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" />
                )}
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="flex items-center mb-3">
                {renderStars(testimonial.rating)}
                <span className="ml-2 text-sm text-gray-600">({testimonial.rating}.0)</span>
              </div>
              
              <p className="text-gray-700 mb-4 italic">"{testimonial.text}"</p>
              
              {testimonial.service && (
                <div className="inline-flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                  <i className="ri-tools-line mr-1"></i>
                  {testimonial.service}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};